const { Conflux, format, address } = require('js-conflux-sdk');

  
const cfx = new Conflux({
    url: 'https://main.confluxrpc.com',
    networkId: 1029,
    defaultGasPrice: 1000000,
    defaultGas: 1000000,
    logger: console,
  });


window.ConfluxJSSDK = {
    format: format,
    address: address
}

window.confluxJS = cfx
window.confluxJS.provider = window.conflux

var account = "";
var zeroAddress = "0x0000000000000000000000000000000000000000";
var token = "";
// var debug_model = window.conflux.chainId == '0x405' ? false : true
var debug_model = false

var defaultGasPrice = 1000000

//测试合约地址
// const contractAddress = {
//     "nft": "cfxtest:type.contract:acfs2s9be4mfjhmcbc0j8ws79dn0nycsx64wrn9n39",
//     "exchange": "cfxtest:type.contract:ach33fwrft3c9twtptb0ectysjhyunuspuc9s6yp76",
//     "auction": "cfxtest:type.contract:achrrh3ndayuax5zkm6nne6mgxjghwj6mjcpfxrhsh",
//     "oracle": "cfxtest:type.contract:acgu8f87xneh4esz3w4c06z1b5c949xw1247jmpj79",
//     "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2"
// }

//正式合约地址
const contractAddress = debug_model ? {
    "nft": "cfxtest:type.contract:acfs2s9be4mfjhmcbc0j8ws79dn0nycsx64wrn9n39",
    "exchange": "cfxtest:type.contract:ach33fwrft3c9twtptb0ectysjhyunuspuc9s6yp76",
    "auction": "cfxtest:type.contract:achrrh3ndayuax5zkm6nne6mgxjghwj6mjcpfxrhsh",
    "oracle": "cfxtest:type.contract:acgu8f87xneh4esz3w4c06z1b5c949xw1247jmpj79",
    "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2"
} : {
    "nft": "cfx:type.contract:acex90xkzw6zxc7ttmdhxwpmue0777sw0epe0mh8ap",
    "old_exchange": "cfx:type.contract:ace0s2mwu1am37hnmg9k7pmmcwzsc8smmjmgea4vyy",
    "old_auction": "CFX:TYPE.CONTRACT:ACEUE9YY6J9VAAGDYT1X7K277H6DHC5E525T4W6R5W",
    "oracle": "cfx:type.contract:acbr5rgyuekaw2y4vr83h4hncj7n6dn0c6h4d6uhnx",
    "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2",
    "blindbox": "cfx:acczvwn5zkz7ujwn8emddfmntfzgntsxh6xf5598bm",
    "userBlindBox": "cfx:aca4bhc9afhxxbxtmsu5kybdajvve8trby9d0kjvzr",
    "exchange": "cfx:acata2svsu8s6mhuvh80zxgkmry9p2abzpdgyvhuds",
    "auction": "cfx:acbcpb6n14vn7gsjggj05pxtyndr39ukh6n9kfpcjh"
}

const abis = {
    "nft721": require('./assets/abi/721.json'),
    "nft": require('./assets/abi/TsArt.json'),
    "exchange": require('./assets/abi/FixedExchangeV2.json'),
    "auction": require('./assets/abi/EnglishExchange.json'),
    "oracle": require('./assets/abi/PriceOracle.json'),
    "token": require('./assets/abi/currency.json'),
    "currency": require('./assets/abi/currency.json'),
    "confi": require('./assets/abi/confi.json'),
    "blindbox": require('./assets/abi/TSpaceMestryBoxMarket.json')
}

const common = {
    "fee_address": "0x1e922851c6e7033828f6ab6c73a0d70cbfcad7a7",
    "fee_rate": 0.025
}


var contracts = {
    nft: {
        address: contractAddress.nft,
        abi: abis.nft,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.nft.abi ,address: contractAddress.nft}) : null
    },
    old_exchange: {
        address: contractAddress.old_exchange,
        abi: abis.exchange,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.exchange.abi ,address: contractAddress.old_exchange}) : null
    },
    old_auction: {
        address: contractAddress.old_auction,
        abi: abis.auction,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.auction.abi ,address: contractAddress.old_auction}) : null
    },
    oracle: {
        address: contractAddress.oracle,
        abi: abis.oracle,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.oracle.abi ,address: contractAddress.oracle}) : null
    },
    blindbox: {
        address: contractAddress.blindbox,
        abi: abis.blindbox,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.blindbox.abi, address: contractAddress.blindbox}) : null
    },
    exchange: {
        address: contractAddress.exchange,
        abi: abis.exchange,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.exchange.abi ,address: contractAddress.exchange}) : null
    },
    auction: {
        address: contractAddress.auction,
        abi: abis.auction,
        contract: typeof window.conflux !== 'undefined' ? window.confluxJS.Contract({abi: abis.auction.abi ,address: contractAddress.auction}) : null
    }
}


export default {
    account,
    zeroAddress,
    token,
    contracts,
    abis,
    contractAddress,
    common,
    defaultGasPrice
}